
//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template (Model.tst).
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------

import { MigrationStatus } from 'enums/MigrationStatus';
import { SiteModel } from './Distribution.Api.Models.Site';
import { MigrationPointerModel } from './Distribution.Api.Models.Migration.MigrationPointer';
import { Model, ModelProperty } from 'models/Model';


export class MigrationSiteModel extends Model<MigrationSiteModel> {
	public static classProperties: ModelProperty[] = [
		
		{ name: 'id', type: 'guid', languageString: 'migrationSite.property.id', isHidden: true },
		{ name: 'hostname', type: 'string', languageString: 'migrationSite.property.hostname' },
		{ name: 'companyName', type: 'string', languageString: 'migrationSite.property.companyName' },
		{ name: 'vatNo', type: 'string', languageString: 'migrationSite.property.vatNo' },
		{ name: 'ip', type: 'string', languageString: 'migrationSite.property.ip' },
		{ name: 'ns', type: 'string', languageString: 'migrationSite.property.ns' },
		{ name: 'siteId', type: 'guid', languageString: 'migrationSite.property.siteId' },
		{ name: 'status', type: 'MigrationStatus', languageString: 'migrationSite.property.status' },
		{ name: 'migrationSourceId', type: 'guid', languageString: 'migrationSite.property.migrationSourceId' },
		{ name: 'site', type: 'SiteModel', languageString: 'migrationSite.property.site', isHidden: true, isObject: true, new: () => { return new SiteModel }, properties: () => { return SiteModel.classProperties } },
		{ name: 'pointers', type: 'MigrationPointerModel[]', languageString: 'migrationSite.property.pointers', isHidden: true, isArray: true, isObject: true, new: () => { return new MigrationPointerModel }, properties: () => { return MigrationPointerModel.classProperties } }
	];
	[key: string]: any;
	
	public id?: string;
	public hostname: string;
	public companyName: string;
	public vatNo: string;
	public ip: string;
	public ns: string;
	public siteId?: string;
	public status: MigrationStatus;
	public migrationSourceId?: string;
	public site?: SiteModel;
	public pointers: MigrationPointerModel[];
    
	constructor(){
		super();
		this.id = undefined;
		this.hostname = '';
		this.companyName = '';
		this.vatNo = '';
		this.ip = '';
		this.ns = '';
		this.siteId = undefined;
		this.status = 0;
		this.migrationSourceId = undefined;
		this.site = undefined;
		this.pointers = [];
		
	}
	getProperties(){
		return MigrationSiteModel.classProperties;
	}
}

